import {
  CloseOutlined,
  PauseOutlined,
  PlayCircleOutlined,
} from "@ant-design/icons";
import { Progress } from "antd";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  AiOutlineDown as ChevronDown,
  AiOutlineUp as ChevronUp,
  AiOutlineDownload as Download,
  AiOutlineClose as X,
} from "react-icons/ai";
import { FaPlayCircle, FaSearchMinus, FaSearchPlus } from "react-icons/fa";
import { FaDownload } from "react-icons/fa6";
import { MdErrorOutline } from "react-icons/md";
import { TfiLayoutWidthDefault } from "react-icons/tfi";
import apiFactory from "../../api";
import { standardizeVolume } from "../../utils/Utils";
import { CustomAvatar } from "../avatar/CustomAvatar";
import ImageDisplay from "../chat/ImageDisplay";
import { SmartVideoPlayer } from "../customComponent/SmartVideoPlayer";
import "./style.scss";

import { LuRotateCcw, LuRotateCw } from "react-icons/lu";
import { TbFlipHorizontal, TbFlipVertical } from "react-icons/tb";
import { useMenuContext } from "../../context/MenuContext";
import { useInfoUser } from "../../store/UserStore";
import { useGlobalDownloader } from '../../context/global/DownloadProvider';

export default function MediaViewerModal({ resourceViewer }) {
  const { languageMap } = useInfoUser();
  const activeRef = useRef(null);
  const scrollRef = useRef(null);
  const [scaleImg, setScaleImg] = useState(1);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [imagePos, setImagePos] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [flipX, setFlipX] = useState(false);
  const [flipY, setFlipY] = useState(false);

  const [sender, setSender] = useState({});
  const imgContainerRef = useRef(null);
  const { selectedConversation } = useMenuContext();

  const allFiles = resourceViewer?.files;

  const currentFile = resourceViewer?.selected;

  console.log("1 ", allFiles)
  console.log("2 ", currentFile)


  const currentIndex = useMemo(() => {
    if (!resourceViewer?.selected) return -1;
    return allFiles.findIndex(
      (f) => f.resourceId === resourceViewer?.selected?.resourceId,
    );
  }, [allFiles, resourceViewer?.selected]);

  const handlePrev = () => {
    if (currentIndex > 0) {
      setTimeout(() => {
        resourceViewer?.setSelected(allFiles[currentIndex - 1]);
      }, 100);
    }
  };

  const handleNext = () => {
    if (currentIndex < allFiles.length - 1) {
      setTimeout(() => {
        resourceViewer?.setSelected(allFiles[currentIndex + 1]);
      }, 100);
    }
  };

  const handleScroll = (e) => {
    const target = e.target;
    const { scrollTop, scrollHeight, clientHeight } = target;

    // --- Scroll top ---
    if (
      scrollTop <= 0 &&
      !resourceViewer?.loadingMedia &&
      resourceViewer?.hasMorePrev
    ) {
      const firstGroup = resourceViewer?.files?.[0];
      if (firstGroup?.createdAt) {
        resourceViewer?.handleOpenViewer(
          null,
          firstGroup?.createdAt,
          "prev",
          scrollRef.current,
        );
      }
    }

    // --- Scroll bottom ---
    if (
      scrollTop + clientHeight >= scrollHeight - 5 &&
      !resourceViewer?.loadingMedia &&
      resourceViewer?.hasMoreNext
    ) {
      const lastGroup =
        resourceViewer?.files?.[resourceViewer?.files?.length - 1];
      if (lastGroup?.createdAt) {
        resourceViewer?.handleOpenViewer(
          null,
          lastGroup?.createdAt,
          "next",
          scrollRef.current,
        );
      }
    }
  };

  const formatDateTime = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const {
    downloads,
    startDownload,
    cancelDownload,
    pauseDownload,
    resumeDownload,
    DOWNLOAD_STATUS,
  } = useGlobalDownloader();

  const [fileState, setFileState] = useState({});
  const fileNameToSave = currentFile?.fileName || "Willo-media";

  const handleResumeDownload = (e) => {
    e.stopPropagation();
    resumeDownload(currentFile?.resourceId, fileNameToSave);
  };

  const handlePauseDownload = (e) => {
    e.stopPropagation();
    pauseDownload(currentFile?.resourceId);
  };

  const handleDownload = (e) => {
    e.stopPropagation();
    startDownload(currentFile?.resourceId, fileNameToSave, 0);
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    cancelDownload(currentFile?.resourceId);
  };

  const renderDownloadButton = useCallback(() => {
    switch (fileState?.status) {
      case DOWNLOAD_STATUS.PAUSED:
        return (
          <div className="flex gap-2">
            <button onClick={handleResumeDownload}>
              <PlayCircleOutlined
                style={{ fontSize: "20px", color: "green" }}
              />
            </button>
            <button onClick={handleCancel}>
              <CloseOutlined style={{ fontSize: "20px", color: "red" }} />
            </button>
          </div>
        );
      case DOWNLOAD_STATUS.DOWNLOADING:
        return (
          <button onClick={handlePauseDownload}>
            <PauseOutlined style={{ fontSize: "20px", color: "white" }} />
          </button>
        );

      case DOWNLOAD_STATUS.SUCCESS:
        return (
          <button onClick={handleDownload}>
            <FaDownload style={{ fontSize: "20px", color: "white" }} />
          </button>
        );
      case DOWNLOAD_STATUS.ERROR:
        return (
          <div className="flex gap-2">
            <button onClick={handleCancel}>
              <CloseOutlined style={{ fontSize: "20px", color: "red" }} />
            </button>
          </div>
        );
      default:
        return (
          <button onClick={handleDownload}>
            <Download style={{ fontSize: "25px", color: "white" }} />
          </button>
        );
    }
  }, [fileState?.status]);

  const handleMouseDown = (e) => {
    if (scaleImg > 1) {
      setIsDragging(true);
      setDragStart({
        x: e.clientX - imagePos.x,
        y: e.clientY - imagePos.y,
      });

      e.preventDefault();
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setImagePos({
        x: e.clientX - dragStart.x,
        y: e.clientY - dragStart.y,
      });

      e.preventDefault();
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleZoomIn = () => {
    if (!imgContainerRef) return;

    setScaleImg((prevScale) => {
      const newScale = Math.min(prevScale + 0.5, 10);

      if (newScale <= 1) {
        setImagePos({
          x: 0,
          y: 0,
        });
      }

      return newScale;
    });
  };

  const handleZoomOut = () => {
    if (!imgContainerRef) return;

    setScaleImg((prevScale) => {
      const newScale = Math.max(prevScale - 0.3, 0.1);

      if (newScale <= 1) {
        setImagePos({ x: 0, y: 0 });
      }

      return newScale;
    });
  };

  const handleCenterLayout = () => {
    setImagePos({ x: 0, y: 0 });
    setScaleImg(1);
  };

  const handleWheel = (e) => {
    if (!imgContainerRef) return;

    setScaleImg((prevScale) => {
      const zoomIntensity = 0.1;
      const newScale =
        e.deltaY < 0
          ? prevScale + zoomIntensity
          : Math.max(prevScale - zoomIntensity, 0.1);

      if (newScale <= 1) {
        setImagePos({ x: 0, y: 0 });
      }
      return Math.min(newScale, 10);
    });
  };

  const handleRotateLeft = () => setRotation((prev) => prev - 90);
  const handleRotateRight = () => setRotation((prev) => prev + 90);

  const handleFlipX = () => setFlipX((prev) => !prev);
  const handleFlipY = () => setFlipY((prev) => !prev);

  const getSender = async () => {
    const result = await apiFactory.userApi.listPerson([currentFile?.userId]);
    if (result?.status !== 200) return;
    setSender(result?.data?.[0]);
  };

  useEffect(() => {
    setScaleImg(1);
    setRotation(0);
    setFlipX(false);
    setFlipY(false);
    if (activeRef.current) {
      activeRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [currentFile]);

  useEffect(() => {
    getSender();
  }, [currentFile?.userId]);

  useEffect(() => {
    if (activeRef?.current && resourceViewer?.isFirstOpen) {
      setTimeout(() => {
        activeRef?.current?.scrollIntoView({
          behavior: "auto",
          block: "center",
        });
        resourceViewer?.setIsFirstOpen(false);
      }, 200);
    }
  }, [resourceViewer?.files]);

  useEffect(() => {
    setFileState(downloads[currentFile?.resourceId]);
  }, [downloads, currentFile?.resourceId]);

  if (!currentFile) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black flex flex-col">
      {/* Header */}
      <div className="flex justify-between items-center p-3 bg-neutral-900 text-white text-sm">
        <span className="font-medium">
          {languageMap[selectedConversation?.name] ||
            selectedConversation?.name}
        </span>
        <button
          onClick={resourceViewer?.handleClose}
          className="p-1 hover:bg-neutral-700 rounded transition"
        >
          <X size={20} />
        </button>
      </div>

      {/* Main content */}
      <div className="flex flex-1 overflow-hidden">
        {/* Main viewer */}
        <div
          className="flex-1 flex justify-center items-center bg-black overflow-hidden"
          onClick={resourceViewer?.handleClose}
        >
          {currentFile?.videoImgResourceId ? (
            <div
              className="display-imgage h-[100%]"
              onClick={(e) => e.stopPropagation()}
            >
              <SmartVideoPlayer
                file={currentFile}
                cssClass={"img-preview h-[100%] pb-[30px]"}
              />
            </div>
          ) : (
            <button
              ref={imgContainerRef}
              className="display-imgage h-[100%]"
              onClick={(e) => e.stopPropagation()}
              onWheel={handleWheel}
              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
              onMouseUp={handleMouseUp}
              onMouseLeave={handleMouseUp}
            >
              <div
                className="h-[100%] flex justify-center items-center"
                style={{
                  transform: `
                    translate(${imagePos.x}px, ${imagePos.y}px)
                    scale(${scaleImg})
                    rotate(${rotation}deg)
                    scaleX(${flipX ? -1 : 1})
                    scaleY(${flipY ? -1 : 1})
                  `,
                  transformOrigin: "center center",
                  transition: "transform 0.15s ease-out",
                  willChange: "transform",
                }}
              >
                <ImageDisplay
                  resourceId={currentFile?.resourceId}
                  imageStyle={{
                    maxHeight: "100%",
                    width: "auto",
                    objectFit: "cover",
                    display: "block",
                    background: "white",
                  }}
                  classNameCss="img-preview"
                  showLoading={false}
                />
              </div>
            </button>
          )}

          <div
            className="absolute bottom-[65px] mr-[130px] left-0 right-0 flex justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <p className="text-gray-300 text-sm bg-black/60 px-3 py-1 rounded-md max-w-[80%] truncate">
              {currentFile?.originalName ||
                currentFile?.fileName ||
                currentFile?.resourceId}
            </p>
          </div>
        </div>

        {/* Sidebar thumbnails grouped by date */}
        <div className="w-[130px] z-10 bg-neutral-950 border-l border-neutral-800 flex flex-col justify-between">
          <button
            onClick={handlePrev}
            className="p-2 hover:bg-neutral-800 transition"
          >
            <ChevronUp size={20} className="text-gray-400 mx-auto" />
          </button>

          <div
            ref={scrollRef}
            onScroll={(e) => handleScroll(e)}
            className="flex flex-col items-center gap-4 overflow-y-auto py-3 scrollbar-custom"
          >
            <div className="flex flex-col items-center gap-3">
              {allFiles?.map((file, index) => {
                const isActive = file?.resourceId === currentFile?.resourceId;
                const dateLabel = `${file?.date?.slice(6, 8)}/${file?.date?.slice(4, 6)}`;

                const showDateHeader =
                  index === 0 || file?.date !== allFiles[index - 1]?.date;

                return (
                  <React.Fragment key={file?.resourceId}>
                    {showDateHeader && (
                      <div className="text-xs font-semibold text-gray-500 mt-2 mb-1">
                        {dateLabel}
                      </div>
                    )}

                    <div
                      ref={isActive ? activeRef : null}
                      className={`relative cursor-pointer rounded overflow-hidden transition-all ${
                        isActive
                          ? "ring-2 ring-[#275efe] p-[1px]"
                          : "opacity-70"
                      }`}
                      onClick={() => {
                        setTimeout(() => {
                          resourceViewer?.setSelected(file);
                        }, 100);
                      }}
                    >
                      <ImageDisplay
                        resourceId={
                          file?.videoImgResourceId || file?.resourceId
                        }
                        previewImgResourceId={file?.previewImgResourceId}
                        classNameCss="w-[90px] rounded m-[1px] h-[80px] object-cover bg-white"
                      />
                      {file?.videoImgResourceId && (
                        <div className="center-play">
                          <FaPlayCircle size={25} />
                        </div>
                      )}
                      <span className="absolute bottom-1 left-1 text-[10px] bg-black/60 text-gray-200 px-1 rounded">
                        {dateLabel}
                      </span>
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          </div>

          <button
            onClick={handleNext}
            className="p-2 hover:bg-neutral-800 transition"
          >
            <ChevronDown size={20} className="text-gray-400 mx-auto" />
          </button>
        </div>
      </div>

      {/* Footer */}
      <div className="flex pr-[130px] items-center justify-between p-3 bg-neutral-900 text-gray-300 text-sm">
        <div className="flex items-center gap-2 min-w-[250px]">
          <CustomAvatar person={sender} pos={-1} styleCss={{}} />
          <div>
            <p className="font-medium leading-tight">{sender?.name}</p>
            <p className="text-xs">
              {formatDateTime(resourceViewer?.selected?.createdAt)}
            </p>
          </div>
        </div>

        <div className="action-image flex items-center gap-2">
          <div className="flex justify-center gap-[10px]">
            <div className="icon-detail cursor-pointer flex gap-5 ">
              {!currentFile?.videoImgResourceId && (
                <>
                  <button
                    className="icon-detail p-1 hover:text-white transition"
                    onClick={handleZoomOut}
                  >
                    <FaSearchMinus size={20} />
                  </button>
                  <button
                    className="icon-detail p-1 hover:text-white transition"
                    onClick={handleCenterLayout}
                  >
                    <TfiLayoutWidthDefault size={20} />
                  </button>
                  <button
                    className="icon-detail p-1 hover:text-white transition"
                    onClick={handleZoomIn}
                  >
                    <FaSearchPlus size={20} />
                  </button>

                  <button
                    className="p-1 hover:text-white transition"
                    onClick={handleRotateLeft}
                  >
                    <LuRotateCcw size={20} />
                  </button>
                  <button
                    className="p-1 hover:text-white transition"
                    onClick={handleRotateRight}
                  >
                    <LuRotateCw size={20} />
                  </button>

                  <button
                    className="p-1 hover:text-white transition"
                    onClick={handleFlipX}
                  >
                    <TbFlipHorizontal size={20} />
                  </button>
                  <button
                    className="p-1 hover:text-white transition"
                    onClick={handleFlipY}
                  >
                    <TbFlipVertical size={20} />
                  </button>
                </>
              )}
              <div className="relative flex items-center">
                {renderDownloadButton()}

                {[DOWNLOAD_STATUS.DOWNLOADING].includes(fileState?.status) && (
                  <div
                    className="absolute left-full gap-2 ml-2 top-1/2 -translate-y-1/2 
                      flex items-center bg-black/40 px-2 py-[2px] rounded-md"
                  >
                    <div className="flex items-center">
                      <Progress
                        className="w-28 flex items-center"
                        percent={fileState?.progress}
                        showInfo={false}
                        strokeColor="#52c41a"
                        size="small"
                      />
                      <div className="text-[grey] text-[10px] ml-2 whitespace-nowrap">
                        {standardizeVolume(
                          (fileState?.progress * currentFile?.volume) / 100,
                        )}{" "}
                        / {standardizeVolume(currentFile?.volume)}
                      </div>
                    </div>

                    {[DOWNLOAD_STATUS.DOWNLOADING].includes(
                      fileState?.status,
                    ) && (
                      <button
                        className="flex items-center"
                        onClick={handleCancel}
                      >
                        <CloseOutlined
                          style={{ fontSize: "20px", color: "white" }}
                        />
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3 w-[250px]"></div>
      </div>
    </div>
  );
}

